const ExtraDelay = 0;

export const UxMetrics = {
  LoadingFade: 600 + ExtraDelay,
  CardOpenDelay: 450 + ExtraDelay,
  CardPreRevealDelay: 450 + ExtraDelay,
  CardRevealDelay: 350 + ExtraDelay,
  CardSplitDelay: 700 + ExtraDelay,
  CardFlipDelay: 150 + ExtraDelay,
  CardClearDelay: 350 + ExtraDelay,
  CardTransferDelay: 350 + ExtraDelay,
  CroupierPreCardDelay: 200 + ExtraDelay,
  CroupierPeekDelay: 500 + ExtraDelay,
  CroupierPeekPause: 650 + ExtraDelay,
  ResultDelay: 500 + ExtraDelay,
  ResultAnimateIn: 400 + ExtraDelay,
  ResultAnimateOut: 600 + ExtraDelay,
  ResultChipCreation: 500 + ExtraDelay,
  ResultChipCollection: 400 + ExtraDelay,
  PlayerSwitchDelay: 300 + ExtraDelay,
  NextPlayerDelay: 500 + ExtraDelay,
  NumberIncrementDuration: 200 + ExtraDelay,
  ChipStackAppear: 200 + ExtraDelay,
  ChipStackTransition: 350 + ExtraDelay,
  ChipStackPostDelay: 200 + ExtraDelay,
  ChipButtonAnimation: 800 + ExtraDelay,
  ChipButtonHoldDelay: 300 + ExtraDelay,
};
